import React from 'react';
import './SearchBar.css';

export default function SearchBar({ value, onChange, placeholder = 'Search…', onClear }) {
  return (
    <div className="searchbar">
      <span className="searchbar-icon">🔍</span>
      <input
        className="searchbar-input"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
      {value && (
        <button className="searchbar-clear" onClick={() => onClear ? onClear() : onChange('')} aria-label="Clear search">
          ✕
        </button>
      )}
    </div>
  );
}
